import { Link } from "react-router-dom";

const stats = [
  { value: "500+", label: "收录资源站" },
  { value: "1200+", label: "连载作品" },
  { value: "日更", label: "无遮拦更新" },
  { value: "24h", label: "在线可看" },
];

export default function Hero() {
  return (
    <section className="relative min-h-[640px] md:min-h-[720px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=stylized%20abstract%20dark%20comic%20manhwa%20illustration%20with%20flowing%20ink%20shapes%2C%20comic%20action%20panels%20and%20speed%20lines%2C%20warm%20coral%20orange%20and%20amber%20glow%20on%20deep%20charcoal%20background%2C%20Korean%20webtoon%20theme%2C%20energetic%20graphic%20art%2C%20high%20contrast%2C%20dramatic%20composition&width=1600&height=900&seq=hero-main-bg&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-50"></div>

      <div className="relative w-full mx-auto max-w-7xl px-4 md:px-6 py-24 md:py-28">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-bold comic-pop">
            <i className="ri-fire-fill"></i>
            한국 무료 만화 · 韩漫资源聚合导航
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl leading-tight text-foreground-950">
            韩国免费漫画
            <span className="block mt-2 text-primary-500 text-2xl md:text-4xl">
              日更无遮拦 · 全集在线看
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base text-foreground-800 leading-relaxed max-w-2xl">
            覆盖韩国免费漫画网站大全与韩漫APP网页双端资源，热门连载新作同步，全集在线、日更无遮拦。
            一个页面帮你理清所有韩国免费漫画资源渠道，收藏即用，从此追更不再迷路。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/ziyuan"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-compass-3-line"></i>
              进入资源导航
            </Link>
            <Link
              to="/tuijian"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-950 font-bold text-sm whitespace-nowrap hover:border-accent-500 hover:text-accent-500 transition-colors"
            >
              <i className="ri-stack-line"></i>
              看看热门连载
            </Link>
          </div>

          <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-950/40 border border-background-300/40 backdrop-blur px-4 py-3">
                <dt className="order-2 text-xs text-foreground-600">{s.label}</dt>
                <dd className="font-heading text-xl md:text-2xl text-accent-500">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="absolute right-6 bottom-8 hidden xl:flex flex-col items-end gap-3 comic-pop">
        <span className="text-foreground-600 text-sm tracking-widest">NEW &amp; HOT</span>
        <span className="text-3xl text-accent-500 text-stroke" style={{ transform: "rotate(-8deg)" }}>
          만화 대방출
        </span>
      </div>
    </section>
  );
}